const RATIO_CLASS = {
    '1:1': 'image-block--1-1',
    '2:1': 'image-block--2-1',
    '3:2': 'image-block--3-2',
    '4:1': 'image-block--4-1',
    '4:3': 'image-block--4-3',
    '16:9': 'image-block--16-9',
    '21:9': 'image-block--21-9',
};

export { RATIO_CLASS };
